import {
  KeyPoints,
  KeyPointsProps,
} from "@/components/molecules/keyPointsCard";
import { Box, chakra } from "@chakra-ui/react";

export interface KeyPointsBlockProps {
  keyPoints: KeyPointsProps[];
}

export default chakra(KeyPointsBlock);
function KeyPointsBlock({ keyPoints }: KeyPointsBlockProps) {
  return (
    <Box
      as="section"
      display="flex"
      flexWrap="wrap"
      justifyContent="center"
      alignItems="stretch"
      gap={5}
    >
      {keyPoints.map((keyPoint, index) => (
        //--index as key is accepted, list is static--//
        <KeyPoints
          key={index}
          title={keyPoint.title}
          icon={keyPoint.icon}
          items={keyPoint.items}
        />
      ))}
    </Box>
  );
}
